import { tns } from "tiny-slider/src/tiny-slider";

setTimeout(function() {
  
  if (document.querySelector(".slider-interviews")) {
    var slider1 = tns({
        container: '.slider-interviews',
        items: 1,
        autoplay: false,
        nav: true,
        controls: true,
        slideBy: 1,
        loop: false,
        prevButton: document.querySelector('.videos-prev'),
        nextButton: document.querySelector('.videos-next'),
        mouseDrag: true,
        preventScrollOnTouch: true,
        responsive: {
          640: {
            gutter: 20,
            items: 1,
          },
          700: {
            gutter: 20,
            items: 1,
          },
          990: {
            items: 3,
            gutter: 20,
          },
          1440: {
            items: 3,
            gutter: 20,
          }
        }
      });

      slider1.events.on("indexChanged", function(info) {
        var medias = Array.prototype.slice.apply(document.querySelectorAll('.b--section-e video'));
        medias.forEach(function(media) {
          media.pause();
        });
      });
    }

    if (document.querySelector(".slider-press")) {
      var slider2 = tns({
        container: '.slider-press',
        items: 1,
        autoplay: false,
        nav: true,
        controls: true,
        arrowKeys: true,
        loop: true,
        prevButton: document.querySelector('.press-prev'),
        nextButton: document.querySelector('.press-next'),
        mouseDrag: true,
        gutter: 10,
        responsive: {
          640: {
            gutter: 20,
            items: 1
          },
          600: {
            gutter: 20
          },
          1200: {
            items: 1
          },
          1280: {
            items: 3
          }
        }
      });

      slider2.events.on("indexChanged", function(info) {
        info.slideItems[info.indexCached+1].classList.remove(
          "opacity-1"
        );
      
        info.slideItems[info.index+1].classList.add(
          "opacity-1"
        );
      });

      document.querySelector(".b--section-e").classList.remove("none");
      document.querySelector(".b--section-d").classList.remove("none");

      //pause all other videos in slider before playing a video
      var medias = Array.prototype.slice.apply(document.querySelectorAll('.b--section-e video'));
      medias.forEach(function(media) {
        media.addEventListener('play', function(event) {
          medias.forEach(function(media) {
            if(event.target !== media) media.pause();
          });
        });
      });
    }
    document.querySelector("#resa").addEventListener("click", ()  => {
      window.sa_event('click_resa');
      console.log("click_resa");
    } );
    document.querySelector("#resa_footer").addEventListener("click", window.sa_event('click_resa'));
}, 500);
